<template>
  <button
    :class="btnClass"
    :disabled="loading || disabled"
    @click="$emit('click')"
  >
    <span v-if="loading" class="my-spinner"></span>
    <span v-else>{{ label }}</span>
  </button>
</template>

<script>
export default {
  props: {
    label: { type: String, default: '送信' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    btnClass: { type: String, default: 'btn btn-primary' },
  }
}
</script>